<template>
    <common-content-spacer v-if="user && user?.item" class="map-tooltip" height="medium">
        <p v-if="user.item?.practice?.practiceType === PracticeTypeEnum.PHYSICIAN" class="map-tooltip__text">
            {{ getPhysicianName }}
        </p>
        <p v-if="getPracticeName" class="map-tooltip__text">{{ getPracticeName }}</p>
        <p v-if="getAddress" class="map-tooltip__address">{{ getAddress }}</p>
    </common-content-spacer>
</template>

<script>
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    export default {
        props: {
            markerData: { type: Object, required: true },
        },

        data() {
            return {
                user: {},
                PracticeTypeEnum: PracticeTypeEnum,
            }
        },

        computed: {
            getAddress() {
                return `${this.user.address || ''}, ${this.user.city || ''} ${this.user.state || ''}, ${this.user.zip || ''}`
            },

            getPhysicianName() {
                return `${this.user.item.firstName || ''} ${this.user.item.middleName ? this.user.item.middleName : ''} ${
                    this.user.item.lastName || ''
                } ${this.user.item.designation || ''}`.trim()
            },

            getPracticeName() {
                if (this.user.item?.practice?.practiceType === PracticeTypeEnum.PHYSICIAN) {
                    return this.user?.item?.practice?.name || ''
                } else {
                    return this.user?.item?.name || ''
                }
            },
        },

        methods: {
            memberAddedToNetwork() {
                this.user.item.isInMyNetwork = true
            },

            checkAvailability(query) {
                const q = { ...this.$route.query, ...query }
                if (!q.subSpecialityId) {
                    const physicianSpecialities = query.target.specialities
                    q.subSpecialityId = physicianSpecialities.find((specObj) => {
                        return Number(specObj.speciality.id) === Number(q.specialityId)
                    }).subSpeciality.id
                }
                this.$router.push({
                    name: 'referrals.new.make',
                    query: q,
                    params: {
                        existingReferral: this.$route.params.existingReferral,
                        originalQuery: this.$route.query,
                    },
                })
            },
        },

        mounted() {
            this.user = this.markerData
        },
    }
</script>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    .map-tooltip {
        margin: 0 auto;
        text-align: center;
        min-width: 220px;
        z-index: 100;

        &__text {
            font-weight: bold;
            font-size: 20px;
            line-height: 32px;
            letter-spacing: 0.5px;
            color: $color-black;
            margin: 0 !important;
        }

        &__address {
            margin: 0 !important;
            margin-top: 10px !important;
            font-size: 1.125rem;
        }
    }
</style>
